import logo from '../image/incomer.png'
import { Link } from 'react-router-dom'
import { useContext, useMemo } from 'react'
import { AppContext } from '../context/AppContext'

const Header = () => {
    const { user, updateData } = useContext(AppContext)

    return useMemo(() => {
        return !user ? null : <header>
            <div className="mobile content">
                <Link className="icon" to="/perfil/"><span className="material-icons">account_circle</span></Link>
                <Link className="logo" to="/"><img src={logo} alt="Incomer" /></Link>
                <a className="icon" onClick={() => updateData('user', 'logout')}><span className="material-icons">logout</span></a>
            </div>
            <div className="desktop content">
                <Link className="logo" to="/"><img src={logo} alt="Incomer" /></Link>
                <div className="user">
                    <Link to="/perfil/">
                        {user?.image && <img src={user.image} alt={user.full_name} /> || <span className="default material-icons">account_circle</span>}
                        <span>{user.full_name}</span>
                    </Link>
                    <a onClick={() => updateData('user', 'logout')}><span className="material-icons">logout</span></a>
                </div>
            </div>
        </header>
    }, [user])
}
export default Header